import * as actionTypes from "./ExpenseClaimType";

const INITIAL_STATE = {
    projectList: [],
    categoryList: [],
    taxList: [],
    locationList: [],
    costcenterList: [],
    itemList: [],
    expenClmList: [],
    expenCustomerList: [],
    expenDocNumList: [],
    duplicateExpDoc: null,
    advanceFilterList: [],
    attachmentList: [],
    attachmentListRow: [],
    seriesList: [],
    expenseClaim: [],
    settingList: [],
    basicFilterData: [],
    userExpensePolicy: [],
    expensePerDiem: [],
    expenseMileage: [],
    supplyList: [],
    customerList: []
};

const ExpenseClaimReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETSELECTCATEGORY:
            return {
                ...state,
                categoryList: action.payload.list,
            };
        case actionTypes.SETLOCLIST:
            return {
                ...state,
                locationList: action.payload.list,
            };
        case actionTypes.SETPRJOLIST:
            return {
                ...state,
                projectList: action.payload.list,
            };
        case actionTypes.SETCOSTCENTRLIST:
            return {
                ...state,
                costcenterList: action.payload.list,
            };
        case actionTypes.SETSELECTTAX:
            return {
                ...state,
                taxList: action.payload.list,
            };
        case actionTypes.SETEXPITEMLIST:
            return {
                ...state,
                itemList: action.payload,
            };
        case actionTypes.EXPCLIAMCLEARDOC:
            return {
                ...state,
                itemList: [],
                expenseClaim: [],
                duplicateExpDoc: [],

            };
        case actionTypes.EXPCLMLIST:
            return {
                ...state,
                expenClmList: action.payload.list,
            };
        case actionTypes.EXPCLMDOCNUMLIST:
            return {
                ...state,
                expenDocNumList: action.payload.list,
            };
        case actionTypes.EXPCLMCUSTOMERLIST:
            return {
                ...state,
                expenCustomerList: action.payload.list,
            };
        case actionTypes.EXPCLMDUPLICATE:
            return {
                ...state,
                duplicateExpDoc: action.payload.data
            }
        case actionTypes.SETEXPCLAIMDOC:
            return {
                ...state,
                expenseClaim: action.payload.data
            }
        case actionTypes.SETEXPADVANCEFILTERLIST:
            return {
                ...state,
                advanceFilterList: action.payload.list
            };
        case actionTypes.SETEXPCLMATTACHMENTLIST:
            return {
                ...state,
                attachmentList: action.payload.list
            };
        case actionTypes.SETEXPCLMATTACHMENTLISTROW:
            return {
                ...state,
                attachmentListRow: action.payload.list
            };
        case actionTypes.SETPOSERIESLIST:
            return {
                ...state,
                seriesList: action.payload.list,
            };
        case actionTypes.SETEXPDEFCLAIMDOC:
            return {
                ...state,
                settingList: action.payload.data
            };
        case actionTypes.SETEXPENSECLAIMBASICFILTERDATA:
            return {
                ...state,
                basicFilterData: { ...action.payload }
            };
        case actionTypes.SETUSEREXPENSEPOLICY:
            return {
                ...state,
                userExpensePolicy: action.payload.list
            };
        case actionTypes.SETEXPENSEPERDIEM:
            return {
                ...state,
                expensePerDiem: action.payload
            };
        case actionTypes.SETEXPENSEMILEAGE:
            return {
                ...state,
                expenseMileage: action.payload
            };
        case actionTypes.SETSUPPLYLIST:
            return {
                ...state,
                supplyList: action.payload.list
            };
        case actionTypes.SETCUSTOMERLIST:
            return {
                ...state,
                customerList: action.payload.list
            };
        default:
            return state;
    }
}

export default ExpenseClaimReducer;